import { APP_BRANDS, useAppBrand } from '@vivaldis/common'
import { BrandsEnum } from '@vivaldis/graphql'

export function getGraphQLBrand(
  appBrand: ReturnType<typeof useAppBrand>
): BrandsEnum {
  return appBrand === APP_BRANDS.BrickJobs
    ? BrandsEnum.BRICKJOBS
    : BrandsEnum.VIVACONNECT
}

export function useGraphQLBrand(): BrandsEnum {
  const appBrand = useAppBrand()
  return getGraphQLBrand(appBrand)
}
